import { bindable } from 'aurelia-framework';

import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.css';

export class MultiComplete {
    @bindable service;
    @bindable values;
    @bindable items;

    attached () {
        this.select = new TomSelect(this.element, {
            maxItems: null,
            create: false,
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            options: this.items != null && this.items.length > 0 ? this.items : [],
            items: this.values,
            load: async (query, callback) => {
                const items = await this.service.filterTopThree(query);
                callback(items);
            },
            onItemAdd: (value, $item) => {
                this.values.push(value);
            },
            onItemRemove: (value) => {
                const index = this.values.indexOf(value);
                if (index > -1) {
                    this.values.splice(index, 1);
                }
            }
        });
    }
}
